import React from 'react';
import ReactDOM from 'react-dom/client';
import './Css/index.scss';
import Main from './Main';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>
);



